import React from 'react';
import { X } from 'lucide-react';
import Sidebar from './Sidebar';
import { useTheme } from '../../hooks/useTheme';

const MobileMenu = ({ show, onClose }) => {
  const { theme } = useTheme();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className={`fixed left-0 top-0 h-full ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-xl`}>
        <div className="p-4 flex justify-end">
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <Sidebar />
      </div>
    </div>
  );
};

export default MobileMenu;